"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Div_1 = __importDefault(require("../../Div"));
var cardStyles = {
    card: {
        display: 'inline-block',
        verticalAlign: 'middle',
        margin: '0px 5px 15px',
        boxShadow: '15px 15px 15px rgba(0,0,0,0.4)',
        borderRadius: 20,
        position: 'relative',
        overflow: 'hidden'
    },
    card1: {
        width: 1700,
        height: 1000,
        margin: 'auto'
    },
    card2: {
        width: 890,
        height: 1020
    },
    card4: {
        width: 910,
        height: 500
    },
    card6: {
        width: 600,
        height: 510
    },
    card8: {
        width: 450,
        height: 510
    }
};
var generateCardStyle = function (itemsCount) {
    var cardSizeStyle = cardStyles.card8;
    if (itemsCount === 1) {
        cardSizeStyle = cardStyles.card1;
    }
    else if (itemsCount === 2) {
        cardSizeStyle = cardStyles.card2;
    }
    else if (itemsCount < 5) {
        cardSizeStyle = cardStyles.card4;
    }
    else if (itemsCount < 7) {
        cardSizeStyle = cardStyles.card6;
    }
    else if (itemsCount < 9) {
        cardSizeStyle = cardStyles.card8;
    }
    return __assign(__assign({}, cardStyles.card), cardSizeStyle);
};
var Card = function (_a) {
    var itemsCount = _a.itemsCount, children = _a.children;
    return (react_1.default.createElement(Div_1.default, { id: 'grid-item-card', styles: generateCardStyle(itemsCount) }, children));
};
exports.default = Card;
//# sourceMappingURL=Card.js.map